var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-element-loading',{attrs:{"active":_vm.active,"color":"#fff","background-color":_vm.getBgColor(),"text":_vm.loaderText,"text-style":{fontSize: '1.3em'},"is-full-screen":_vm.isFullScreen}})}
var staticRenderFns = []

export { render, staticRenderFns }